import { cn } from "@newxsystems/shared";
import { VelvetCardLink } from "../VelvetCardLink/VelvetCardLink";
import { VelvetMedia } from "../VelvetMedia/VelvetMedia";
import { VelvetRichText } from "../VelvetRichText/VelvetRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => (
  <div
    className={cn("grid grid-cols-1 gap-x-5 gap-y-16 sm:grid-cols-2", columns[columnCount || 3])}
  >
    {items.map((item, index) => (
      <VelvetCardLink
        className={cn("overflow-visible border-0", index % 2 === 1 && "lg:mt-24")}
        key={index}
        link={item.cardLink}
      >
        <VelvetMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className={cn("border border-parchment/20", index % 2 === 0 && "velvet-arch")}
          imageClassName="transition-transform duration-300 ease-out group-hover:scale-[1.02]"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
        <div className="relative z-10 border-t border-parchment/40 pt-5">
          <h3 className="font-velvet-display text-4xl font-black uppercase leading-[0.88] tracking-[-0.035em] transition-colors group-hover:text-thread">
            {item.heading}
          </h3>
          {item.description ? (
            <VelvetRichText
              className="mt-4 text-base text-smoke md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
      </VelvetCardLink>
    ))}
  </div>
);

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
